import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { awsBaseUrl } from "../../helper";

const EditSurveySettingModal = ({ surveySettingModal, surveySettingToggle, surveysListDetails, surveyIndex, surveyActions }) => {

  const [survey, setSurvey] = useState({
    title: "",
    description: "",
    banner: ""
  });
  const [surveySetting, setSurveySetting] = useState({
    private: null,
    anonymity: null,
    liveResult: null,
    thanks: ""
  });
  const [tempImg, setTempImg] = useState("");
  const inputFileRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (surveysListDetails?.length > 0) {
      setSurvey({
        title: surveysListDetails[surveyIndex]?.title,
        description: surveysListDetails[surveyIndex]?.description,
        banner: surveysListDetails[surveyIndex]?.banner
      });
      setSurveySetting({
        private: surveysListDetails[surveyIndex]?.surveySettings?.private,
        anonymity: surveysListDetails[surveyIndex]?.surveySettings?.anonymity,
        liveResult: surveysListDetails[surveyIndex]?.surveySettings?.liveResult,
        thanks: surveysListDetails[surveyIndex]?.surveySettings?.thanks
      });
    } else {
      setSurvey({
        title: "",
        description: "",
        banner: ""
      });
      setSurveySetting({
        private: null,
        anonymity: null,
        liveResult: null,
        thanks: ""
      });
    }
  }, [surveysListDetails, surveyIndex, surveySettingToggle]);

  const editSurveySettings = () => {
    dispatch(surveyActions.adminUpdateSurveyDetailsSettings(surveysListDetails[surveyIndex]?._id, { surveyDetails: survey, surveySetting }, surveySettingToggle));
  };

  const clickChangeIcon = () => {
    inputFileRef.current.click();
  };

  const onFileChange = (e) => {
    setTempImg(URL.createObjectURL(e.target.files[0]));
    setSurvey({
      ...survey,
      banner: {
        file: e.target.files[0]
      }
    });
  };

  return (
    <React.Fragment>
      <Modal isOpen={surveySettingModal} toggle={surveySettingToggle} backdrop={"static"} className="modal-lg" centered>
        <ModalHeader>
          <h4>Update Survey Setting</h4>
        </ModalHeader>
        <ModalBody className='p-3'>
          <Row>
            <Col md="3" className="mt-3 mb-3" style={{ position: "relative" }}>
              <img src={tempImg ? tempImg : `${awsBaseUrl}${survey?.banner}`} style={{ height: "120px", width: "100%" }} />
              <i className="fa-solid fa-pen-to-square" style={{ position: "absolute", bottom: "5px", right: "17px", filter: "drop-shadow(3px 3px 10px #000)", cursor: "pointer", color: "#fff" }} onClick={e => clickChangeIcon()}></i>
              <input type="file" accept="image/*" style={{ display: "none" }} ref={inputFileRef} onChange={e => onFileChange(e)} />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Title</Label>
                <Input type="text" value={survey?.title} onChange={e => setSurvey({ ...survey, title: e.target.value })} />
              </FormGroup>
              <FormGroup>
                <Label>Description</Label>
                <textarea className="form-control" value={survey?.description} onChange={e => setSurvey({ ...survey, description: e.target.value })} />
              </FormGroup>
              <FormGroup>
                <Label>Thanks</Label>
                <Input type="text" value={surveySetting?.thanks} onChange={e => setSurveySetting({ ...surveySetting, thanks: e.target.value })} />
              </FormGroup>
            </Col>
            <Col md="6">
              <Row className="mt-4">
                <p>Survey Settings</p>
                <Col md="6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="surveyPrivacyModal"
                      id="privacyModal"
                      checked={surveySetting?.private}
                      onChange={e => setSurveySetting({ ...surveySetting, private: true })}
                    />
                    <label class="form-check-label" for="privacyModal">
                      Private
                    </label>
                  </div>
                </Col>
                <Col md="6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="surveyPrivacyModal"
                      id="privacy2Modal"
                      checked={!surveySetting?.private}
                      onChange={e => setSurveySetting({ ...surveySetting, private: false })}
                    />
                    <label class="form-check-label" for="privacy2Modal">
                      Public
                    </label>
                  </div>
                </Col>
              </Row>
              <div class="form-check mt-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckDefaultModal"
                  checked={surveySetting?.anonymity}
                  onChange={e => setSurveySetting({ ...surveySetting, anonymity: !surveySetting.anonymity })}
                />
                <label class="form-check-label" for="flexCheckDefaultModal">
                  Allow anonymity
                </label>
              </div>
              <Row className="mt-3">
                <Col md="6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="resultModal"
                      id="resultModal"
                      checked={surveySetting?.liveResult}
                      onChange={e => setSurveySetting({ ...surveySetting, liveResult: true })}
                    />
                    <label class="form-check-label" for="resultModal">
                      Live results
                    </label>
                  </div>
                </Col>
                <Col md="6">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="resultModal"
                      id="result2Modal"
                      checked={!surveySetting?.liveResult}
                      onChange={e => setSurveySetting({ ...surveySetting, liveResult: false })}
                    />
                    <label class="form-check-label" for="result2Modal">
                      Results at the end
                    </label>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={e => {
            surveySettingToggle();
          }}>Cancel</Button>
          <Button color="warning" onClick={e => {
            editSurveySettings()
          }}>Save</Button>{' '}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
};

export default EditSurveySettingModal;